import React from 'react';
import Skeleton from 'components/Skeleton';
import styles from './DashboardSkeleton.module.css';

export const KPISkeleton: React.FC = () => {
  return (
    <div className={styles.kpiGrid}>
      {[1, 2, 3, 4].map((i) => (
        <Skeleton key={i} height={120} />
      ))}
    </div>
  );
};

export const ChartSkeleton: React.FC = () => {
  return <Skeleton height={350} />;
};

export const ListSkeleton: React.FC<{items?: number}> = ({items = 5}) => {
  return (
    <div className={styles.listContainer}>
      {[...Array(items)].map((_, i) => (
        <Skeleton key={i} height={80} />
      ))}
    </div>
  );
};

